import React from 'react';
import _ from 'lodash';
import {loadReCaptcha} from 'react-recaptcha-google'
import {Case, Switch} from './switch-case';
import { CheckoutOrderDataBox, CheckoutPaymentButtonBox, CheckoutQrBox} from './CheckoutBox';
import CheckoutHeader from './CheckoutHeader';
import CheckoutForm from './CheckoutForm';
import ResultMessage from './ResultMessage';
import ProductNotFound from './ProductNotFound';
import ProductNotAvailable from './ProductNotAvailable';
import geopagos from '../assets/powered_by_geopagos.png';
import {CHECKOUT_TYPE_BUTTON, CHECKOUT_TYPE_ORDER, CHECKOUT_TYPE_QR} from '../constants';
import Error from "./Error";

function isValidJson(json) {
  try {
    JSON.parse(json);
    return true;
  } catch (error) {
    return false;
  }
}

function validateUrl(url){
  if(!url.startsWith('https://')){
    url = 'https://' + url;
  }
  return url;
}

class Checkout extends React.Component {

  state = {
    product: null,
    result: null,
    resultNotAvailable: null,
    language: 'es',
    quantity: 1,
    paymentButtonInvalidLink: null,
    paymentType: 'CARD',
    conversion: null,
    error: null,
    privacyPolicies: null,
    merchantIdentifier: null,
  }

  handleChangeQuantity(value) {
    this.setState({
      quantity: value
    })
  }

  handleChangePaymentMethod(type, conversion) {
    this.setState({
      paymentType: type,
      conversion: conversion
    });
  }

  componentDidMount() {
    loadReCaptcha();
    const productInfo = document.getElementById('productInfo');
    const resultInfo = document.getElementById('resultInfo');
    const errorInfo = document.getElementById('errorInfo');
    const resultNotAvailableId = document.getElementById('resultNotAvailable');
    const recaptchaEnabledElement = document.getElementById('recaptchaEnabled');
    const recaptchaPublicKeyElement = document.getElementById('recaptchaPublicKey');
    const privacyPoliciesInfo = document.getElementById('configurationInfo');

    let product = productInfo && JSON.parse(productInfo.innerHTML);
    let privacyPolicies = privacyPoliciesInfo && JSON.parse(privacyPoliciesInfo.innerHTML);
    let error = errorInfo && JSON.parse(errorInfo.innerHTML);
    const result = resultInfo && JSON.parse(resultInfo.innerHTML);
    const resultNotAvailable = resultNotAvailableId && JSON.parse(resultNotAvailableId.innerHTML);
    const tokensWithoutRecaptch = [
      'Njc3ZjY1MDBkOS43OGUwODlhODZiMzAxNzM0Mzg2Njgz',
      'YTM2ZC4xNjYwMzIxYjdhYzY2Njc2NjUxNzM0NDU1OTE3',
      'NmY3OGE2NDkxMTEzZC5iYjE3NTY5NjUxNzM2MjYxNTU2',
      'ZDcuZDMxNzQwNWI2MzM3Njc2Mjc2ODIxNzM2MjYyMzU3',
      'ZjczZTQ0ODcwLjM0OTYwNDBlNzBkN2MxNzM2MjY1NDcy',
      'ZTZlLjgyOTYxNmU0MmJkOGMyNDZmMzExNzI2Njg1MDA2'
    ];
    const recaptchaEnabled = recaptchaEnabledElement && recaptchaEnabledElement.innerHTML === "1" && !tokensWithoutRecaptch.includes(product['token']);
    const recaptchaPublicKey = recaptchaPublicKeyElement && recaptchaPublicKeyElement.innerHTML;

    if (product) {
      localStorage.setItem('merchantName', product['merchantName']);
      localStorage.setItem('subsidiaryImageFilename', product['subsidiaryImageFilename']);
      localStorage.setItem('productLanguage', product['language']);
      localStorage.setItem('referer', (product['referer'] || null));
      localStorage.setItem('redirectUrls',(product['redirectUrls']));
    } else if (resultInfo) {
      const merchantName = localStorage.getItem('merchantName');
      const strImageFileName = localStorage.getItem('subsidiaryImageFilename');
      const productLanguage = localStorage.getItem('productLanguage');
      const productReferer = localStorage.getItem('referer');
      const redirectUrls = isValidJson(localStorage.getItem('redirectUrls')) ? localStorage.getItem('redirectUrls') : "";
      const token = result['token'];
      if (merchantName && strImageFileName) {
        const subsidiaryImageFilename = (strImageFileName && (strImageFileName !== 'null')) ?
          strImageFileName : null;
        product = {
          merchantName: merchantName,
          subsidiaryImageFilename: subsidiaryImageFilename,
          referer: productReferer,
          urls: redirectUrls
        };

        if(productLanguage) {
          product['productLanguage'] = productLanguage;
        }
      }

      if (isValidJson(redirectUrls)){
        let urlsJson = JSON.parse(redirectUrls);
        localStorage.setItem('referer', (validateUrl(urlsJson.failed + "?order_id=" + token) || null));
        setTimeout(function() {
          if (result.response === "1" || result.response === "00" ) {
            window.location.replace(validateUrl(urlsJson.success + "?order_id=" + token));
            return;
          }
        }, 3000);
      }
    }

    this.setState({
      product: product,
      result: result,
      resultNotAvailable: resultNotAvailable,
      recaptchaEnabled: recaptchaEnabled,
      recaptchaPublicKey: recaptchaPublicKey,
      error: error,
      privacyPolicies: privacyPolicies,
      language: (_.hasIn(product, 'language') && product.language) || 'es'
    });
  }

  render() {
    const {
      product,
      result,
      resultNotAvailable,
      quantity,
      recaptchaEnabled,
      recaptchaPublicKey,
      error,
      privacyPolicies,
      merchantIdentifier
    } = this.state

    let isButton = (result && result.isButton) || (product && product.type === CHECKOUT_TYPE_BUTTON);

    return (
      <div className="main-checkout">
        <CheckoutHeader
          merchantName={product && product['merchantName']}
          subsidiaryImageFilename={product && product['subsidiaryImageFilename']}
          isButton={isButton}
        />
        <div className="main-body">
          <Switch>
            <Case condition={error}>
              <Error generic={error} message={error && error['message']} />
            </Case>
            <Case condition={resultNotAvailable}>
              <ProductNotAvailable/>
            </Case>
            <Case condition={result}>
              <ResultMessage
                  result={result}
              />
            </Case>
            <Case condition={product && product['expired']}>
              <ProductNotAvailable expired={product && product['expired']}/>
            </Case>
            <Case condition={product && product.token && (product.maxElements == 0)}>
              <ProductNotAvailable/>
            </Case>
            <Case condition={product && product.token && product.type}>
              <div className="container">
                <div className="checkout-grid">
                  <aside className="checkout-aside">
                    {(() => {
                      if ( product && product.type === CHECKOUT_TYPE_BUTTON) {
                        return (
                            <CheckoutPaymentButtonBox
                                product={product}
                                quantity={quantity}
                                paymentType={this.state.paymentType}
                                conversion={this.state.conversion}
                                onChangeQuantity={this.handleChangeQuantity.bind(this)}
                            />
                        )
                      } else if (product && product.type === CHECKOUT_TYPE_ORDER) {
                        return (
                            <CheckoutOrderDataBox
                                product={product}
                                quantity={quantity}
                                paymentType={this.state.paymentType}
                                conversion={this.state.conversion}
                            />
                        )
                      } else if (product && product.type === CHECKOUT_TYPE_QR){
                        return (
                            <CheckoutQrBox
                                product={product}
                                quantity={quantity}
                                paymentType={this.state.paymentType}
                                conversion={this.state.conversion}
                                onChangeQuantity={this.handleChangeQuantity.bind(this)}
                            />
                        );
                      }
                    })()}
                  </aside>
                  <article className="checkout-payment-form">
                    <CheckoutForm
                      product={product}
                      recaptchaEnabled={recaptchaEnabled}
                      recaptchaPublicKey={recaptchaPublicKey}
                      quantity={quantity}
                      onChangePaymentMethod={this.handleChangePaymentMethod.bind(this)}
                      isButton={isButton}
                      privacyPolicies={privacyPolicies}
                    />
                    <div className="powered-info">
                      <img src={geopagos} alt="GeoPagos"/>
                    </div>
                  </article>
                </div>
              </div>
            </Case>
            <ProductNotFound/>
          </Switch>
        </div>
      </div>
    )
  }
}

export default Checkout;





// WEBPACK FOOTER //
// ./client/components/Checkout.js